/* eslint-disable no-unused-vars */

import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';

import AddNewWorkOrder from './add-new-work-order';
import AddNewInspection from './add-new-inspection';
import AddNewWorkRequest from './add-new-work-request';
import AddNewHseEvents from './add-new-hse-events';
import AddNewCheck from './add-new-check';
import AddNewEquipment from './add-new-equipment';
import AddNewPSVEquipment from './add-new-psv-equipment';
import { getAppDispatch } from '@utilities/dispatch.util';
import { siteMapActions } from '@redux/slices/site-map';

const AddNewWizards = ({
  addNew,
  setAddNew,
  setActive,
  setSelectedPSVEvent = () => {},
  alreadyAttachedPSV = [],
  siteId = null
}) => {
  const dispatch = getAppDispatch();

  useEffect(() => {
    dispatch?.(siteMapActions.setShowMapView(false));
  }, [dispatch]);

  return (
    <div>
      {addNew === 'inspection' || addNew === 'inspectionAsset' ? (
        <AddNewInspection
          asset={addNew === 'inspectionAsset'}
          setAddNew={setAddNew}
          setActive={setActive}
        />
      ) : addNew === 'work-request' ? (
        <AddNewWorkRequest setAddNew={setAddNew} setActive={setActive} />
      ) : addNew === 'work-order' ? (
        <AddNewWorkOrder setAddNew={setAddNew} setActive={setActive} />
      ) : addNew === 'hse-event' || addNew === 'hse-eventAsset' ? (
        <AddNewHseEvents
          setAddNew={setAddNew}
          setActive={setActive}
          asset={addNew === 'hse-eventAsset'}
        />
      ) : addNew === 'check' || addNew === 'checkAsset' ? (
        <AddNewCheck setAddNew={setAddNew} setActive={setActive} asset={addNew === 'checkAsset'} />
      ) : addNew === 'equipment' || addNew === 'new-equipmentAsset' ? (
        <AddNewEquipment
          setAddNew={setAddNew}
          setActive={setActive}
          asset={addNew === 'new-equipmentAsset'}
        />
      ) : addNew === 'psv-equipment' ? (
        <AddNewPSVEquipment
          setAddNew={setAddNew}
          setActive={setActive}
          asset={addNew === 'new-equipmentAsset'}
          setSelectedPSVEvent={setSelectedPSVEvent}
          alreadyAttachedPSV={alreadyAttachedPSV}
          siteId={siteId}
        />
      ) : (
        ''
      )}
    </div>
  );
};

AddNewWizards.propTypes = {
  addNew: PropTypes.string.isRequired,
  setAddNew: PropTypes.func,
  setActive: PropTypes.func
};

export default memo(AddNewWizards);
